import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import DhammaAssistantPanel from "../../components/DhammaAssistantPanel";

export default function PlatformAssistant() {
  return (
    <div className="px-4 sm:px-8 lg:px-10 py-8 max-w-4xl mx-auto" data-testid="platform-assistant">
      <Link to="/platform" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy mb-5">
        <ArrowLeft size={14} /> Back to dashboard
      </Link>
      <div className="flex items-center gap-3 mb-2">
        <div className="p-2 bg-gradient-to-br from-[#6C4EFF] to-[#2D5BFF] text-white rounded-lg">
          <Sparkles size={18} />
        </div>
        <div>
          <h1 className="font-display text-3xl text-navy leading-tight">AI Dhamma Assistant</h1>
          <p className="text-xs uppercase tracking-[0.2em] text-saffron">Beta · Your Dhamma Guide</p>
        </div>
      </div>
      <p className="mt-3 text-navy/65 max-w-2xl text-sm">
        Ask anything about the Buddha's teachings, Babasaheb's writings, or our Sangha. Trained on the
        Pāli canon, the Annihilation of Caste, The Buddha and His Dhamma, and the lives of the
        Ambedkarite reformers. Powered by Gemini.
      </p>
      <div className="mt-6">
        <DhammaAssistantPanel fullPage />
      </div>
    </div>
  );
}
